/**
 * @generated SignedSource<<0be33109302f68996369a44a157b7559>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteAssetInput = {
  assetId: string;
  clientMutationId?: string | null | undefined;
};
export type OpsAssetPageDeleteMutation$variables = {
  input: DeleteAssetInput;
};
export type OpsAssetPageDeleteMutation$data = {
  readonly deleteAsset: {
    readonly deletedAssetTag: any | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsAssetPageDeleteMutation = {
  response: OpsAssetPageDeleteMutation$data;
  variables: OpsAssetPageDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAssetPayload",
    "kind": "LinkedField",
    "name": "deleteAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAssetTag",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsAssetPageDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsAssetPageDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "17bdd595bc60f0900c7da238909dd99a",
    "id": null,
    "metadata": {},
    "name": "OpsAssetPageDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OpsAssetPageDeleteMutation(\n  $input: DeleteAssetInput!\n) {\n  deleteAsset(input: $input) {\n    deletedAssetTag\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee0d022202f93c3bba31f197071362bf";

export default node;
